export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m15.395 4-.705 4.001h-3.97L11.426 4H9.395L8.69 8.001H4.705L4.352 10h3.984l-.704 4H3.647l-.352 2.001h3.984L6.573 20h2.032l.705-3.999h3.969L12.574 20h2.03l.706-3.999h3.985L19.648 14h-3.986l.705-4h3.985l.353-1.999h-3.984L17.425 4zm-5.027 6h3.97l-.706 4h-3.97z\"/>"
};